import {BaseExportsController} from './base-controller';
import rsvpConfig from '../../../components/deposits/rsvps';

export default class VouchersExportsController extends BaseExportsController {

    constructor($scope, $rootScope, $injector) {
        super($scope, $rootScope, $injector);
        this.voucherTemplatesStore = this.injector.get('VoucherTemplates').reset({
            persist: false,
            listview: 'LoadVoucherTemplatesForExportsListView'
        });
    }

    getSideNavActions() {
        return [
            {
                label: 'By customer and booking',
                view: 'grouped_by_customer_and_booking',
                description: 'Exports all vouchers grouped by customers and bookings',
                path: 'exports/vouchers/by-customer-and-booking',
                fileName: 'VouchersGroupedByCustomerAndBooking.xlsx',
                fields: [
                    'voucher_templates'
                ],
                activator: () => {
                    this.currentData = {
                        voucher_templates: []
                    }
                }
            }
        ];
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/exports/controllers/vouchers-controller.js